import { Toaster, Toast } from '@/components/ui/lib/toast';
import { Portal } from '@/components/ui/lib/portal';
import { Stack } from '@/components/ui/lib/stack';
import { toaster } from '@/components/ui/lib/toast-utils';

const SaveToast = () => (
  <Portal>
    <Toaster toaster={toaster} insetInline={{ mdDown: '4' }}>
      {(toast) => (
        <Toast.Root width={{ md: 'sm' }}>
          <Toast.Indicator />
          <Stack gap="1" flex="1" maxWidth="100%">
            {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
            {toast.description && <Toast.Description>{toast.description}</Toast.Description>}
          </Stack>
          {toast.action && <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>}
          <Toast.CloseTrigger />
        </Toast.Root>
      )}
    </Toaster>
  </Portal>
);

export default SaveToast;
